import {
  IGetPropertyProgressDTO,
  IGetPropertyProgressResponse,
  IResetPropertyStepDTO,
  IResetPropertyStepResponse,
  getPropertyEndpoints,
  TPropertyAdActionResponse,
  IStopPropertyAdDTO,
} from '@/models/propertyProgress.model';
import { ApiResponse, httpClient } from '@/utils';

class PropertyProgressAPI {
  static getPropertyProgress(data: IGetPropertyProgressDTO): ApiResponse<IGetPropertyProgressResponse> {
    const { GET_PROPERTY_PROGRESS } = getPropertyEndpoints(data);
    return httpClient.get<IGetPropertyProgressResponse>(GET_PROPERTY_PROGRESS);
  }

  static resetPropertyStep(data: IResetPropertyStepDTO): ApiResponse<IResetPropertyStepResponse> {
    const { RESET_PROPERTY_STEP } = getPropertyEndpoints(data);
    return httpClient.patch<IResetPropertyStepResponse>(RESET_PROPERTY_STEP, { keep_data: !data?.clearData });
  }

  static stopPropertyAd(data: IStopPropertyAdDTO): ApiResponse<TPropertyAdActionResponse> {
    const { PROPERTY_AD_STOP } = getPropertyEndpoints(data);

    return httpClient.post<TPropertyAdActionResponse>(PROPERTY_AD_STOP);
  }
}

export default PropertyProgressAPI;
